import type { MagicPlaceStatus } from '@api/types'
import { useI18n } from '@i18n/I18nProvider'

const DOT: Record<MagicPlaceStatus, string> = {
	received: 'bg-ochre',
	approved: 'bg-healthy',
	retired: 'bg-earth-600',
}

// Estado de un lugar mágico para el personal: punto de color y SIEMPRE su nombre.
export const MagicStatusBadge = ({ status }: { status: MagicPlaceStatus }) => {
	const { t } = useI18n()
	return (
		<span className="inline-flex items-center gap-2 rounded-full bg-earth-100 px-3 py-1 text-sm font-semibold text-earth-800">
			<span className={`size-2.5 rounded-full ${DOT[status]}`} aria-hidden="true" />
			{t(`magic.status.${status}`)}
		</span>
	)
}
